import {Entity} from "./entity";
import {Expose} from "class-transformer";
import {Employee} from "./employee.entity";
import {Public} from "../../decorators/public.decorator";
import {WeekDayName} from "../../enums/week-day-name.enum";

export class WeeklyWorkingTime extends Entity<WeeklyWorkingTime> {

    /**
     * Back-reference to the owning employee. Create/UpdateWeeklyWorkingTimeCommand read
     * `employee.uid` in their constructor, so this must always be set — and it arrives in two
     * shapes: the create path (WeeklyWorkingTimeRepository.create) assigns the Employee itself,
     * while the load path (DtoToWeeklyWorkingTimeTransformer) assigns a promise carrying its own
     * uid, because the dto only delivers a uid string and awaiting it there would re-enter the
     * employee transform. Both readers need `.uid` only, and synchronously — which both shapes
     * provide.
     */
    @Public()
    @Expose()
    employee!: Employee | (Promise<Employee> & { uid: string });

    @Public()
    @Expose()
    monday = 8;

    @Public()
    @Expose()
    tuesday = 8;

    @Public()
    @Expose()
    wednesday = 8;

    @Public()
    @Expose()
    thursday = 8;

    @Public()
    @Expose()
    friday = 8;

    @Public()
    @Expose()
    saturday = 0;

    @Public()
    @Expose()
    sunday = 0;

    getByName(weekDayName: WeekDayName): number {
        return Reflect.get(this, weekDayName)!;
    }

    setByName(weekDayName: WeekDayName, value: number): void {
        Reflect.set(this, weekDayName, value);
    }

    /**
     * Identifies the record by its uid; the hours per weekday are its content, not its name.
     */
    public toString(): string {
        return `WeeklyWorkingTime ${this.uid}`;
    }

}